import type { ReactNode } from 'react'

// The status label.
//
// # THE RULES IT CARRIES
//
// One or two words in sentence case, a colour and a dot, and never a button:
// a status that can be clicked reads as an action and gets clicked. Finished
// states go quiet, which is what the plain tone is for ("Signed", "Done"), so
// the eye lands on what still needs somebody. The colour is never the only
// signal, because the word is always there.

export type Tone = 'neutral' | 'info' | 'ok' | 'warn' | 'crit' | 'special' | 'brand' | 'plain'

export function Status({ tone, children, title }: { tone: Tone; children: ReactNode; title?: string }) {
  return (
    <span className={'kit-status kit-' + tone} title={title}>
      {children}
    </span>
  )
}
